import { FACETED_SEARCH_QUERY } from '../Actions/FacetedSearch.action';

function isUriEncoded(str) {
    return decodeURIComponent(str) !== str;
}

function handleSearchQueryChange(payload) {
    let { query } = payload;

    query = !isUriEncoded(query) ? encodeURI(`${query?'?':''}${query}`) : `${query?'?':''}${query}`;
    const url = window.location.href.replace(window.location.search, '') + query;
    window.history.pushState('search', 'Search Page', url);
}

export const historyMiddleware = store => next => action => {
    const {type, payload} = action;
    switch (type) {
        case FACETED_SEARCH_QUERY:
            handleSearchQueryChange(payload);
            break;
    }
    next(action);
}
